/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import React, { useState } from 'react'
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { Box, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from '@mui/material';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import moment from 'moment';
import { convertCountToOrder } from 'src/services/countandorderServices';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

interface ConvertToOrderInputs {
    contractType?: string;
    expirationDate?: string;
    rentalCount?: number | null;
    emailTierToAppend?: string;
}

interface PropsType {
    closeModal: () => void;
    selectedJobId: number;
    jiraID: string;
    refreshData: () => void;
    setConvertErrorMessage: (message: string) => void;
}

const validationSchema = Yup.object().shape({
    contractType: Yup.string().required("Please select contract type"),
    expirationDate: Yup.string()
        .when('contractType', {
            is: (contractType: string) => contractType !== undefined && contractType === 'L',
            then: () => Yup.string().required("Please enter expiration date.")
        }).nullable(),
    rentalCount: Yup.string()
        .when('contractType', {
            is: (contractType: string) => contractType !== undefined && contractType === 'R',
            then: () => Yup.number().integer().nullable().min(1, "Rental count should greater than 0.").required("Please enter rental count.")
        }).nullable(),
})

function ConvertToOrder({closeModal, selectedJobId, refreshData, jiraID, setConvertErrorMessage }: PropsType): JSX.Element {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const {
        control,
        handleSubmit,
        clearErrors,
        setValue,
        formState: { errors },
    } = useForm<ConvertToOrderInputs>({
        // @ts-ignore
        resolver: yupResolver(validationSchema),
        mode: 'onSubmit',
        defaultValues: {
            // @ts-ignore
            emailTierToAppend: "1"
        }
    });

    const minDate = moment('2000-01-01');

    const maxDate = moment('2050-12-31');

    const shouldDisableDate = (day: any): boolean => {
        return day.isBefore(minDate, 'day');
    };
    const clearAllNotifications = () : void=> {
        NotificationManager.listNotify.forEach((notification: any) =>
          NotificationManager.remove(notification)
        );
      };
    const onSubmit = (data: ConvertToOrderInputs): void => {
        console.log("xxx")
        setIsLoading(true)
        
        // @ts-ignore
        const userData = JSON.parse(localStorage.getItem("user"))

        const requestData = {
            "jobID": selectedJobId,
            "emailSale_ContractType": data.contractType,
            "emailSale_ExpirationDate": data.expirationDate !== null ? moment(data.expirationDate).toISOString() : moment(new Date()).toISOString(),
            "emailSale_RentalCount": data.rentalCount !== null ? data.rentalCount : 0,
            "emailSale_TierToAppend": data.emailTierToAppend,
            "userId": userData.id,
        }

        convertCountToOrder(requestData)
            .then(
                res => {
                    clearAllNotifications();
                    if(res.status === 200) {
                        if(res.data.result === 1) {
                            NotificationManager.success("Job request converted successfully")
                            refreshData()
                        }else{
                            if(res.data.messages?.length > 0 && res.data.messages[0].type === 2){
                                const message = res.data.messages[0].message;
                                setConvertErrorMessage(message);
                            }else{
                                NotificationManager.error("Unknown error occurred")

                            }
                        }
                        
                    }
                }
            )
            .catch(
                error => console.log(error)
            )
            .finally(
                () => setIsLoading(false)
            )
    }

    return (
        <React.Fragment>
            <Box className="px-[16px] pt-[10px]  mb-[30px]">
                <TextField
                    id="outlined-basic"
                    label={(jiraID !== null && jiraID !== "") ? "Jira ID" : "Job ID"} 
                    variant="outlined"
                    fullWidth
                    name="Description"
                    value={(jiraID !== null && jiraID !== "") ? jiraID : selectedJobId}
                    autoComplete="off"
                    InputProps={{
                        style: {
                            textAlign: 'center',
                            color: '#000000',
                            fontSize: '18px',
                            fontWeight: '700',
                            WebkitTextFillColor: '#000000',

                        },
                    }}
                    sx={{
                        '& .MuiOutlinedInput-root': {
                            backgroundColor: '#e0e0e0', // Gray background color
                            '& fieldset': {
                                borderColor: '#d0d0d0',
                            },
                            '&:hover fieldset': {
                                borderColor: '#b0b0b0',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#D6242C',
                            },
                        },
                        '& input': {
                            textAlign: 'center',
                            padding: '7px', // Adjust padding to fit within the TextField
                            color: '#000000 !important',
                            fontSize: '18px !important',
                            fontWeight: '700 !important',
                            '-webkit-text-fill-color': '#000000 !important',
                            opacity: '1 !important',
                            backgroundColor: '#f5f5f5 !important', // Ensure background color is applied
                        },
                        '& label': {
                            textAlign: 'center',
                            color: '#343434',
                            top: '-6px', // Adjust label position to account for increased padding
                        },
                        '& label.Mui-focused': {
                            color: '#D6242C',
                        },
                    }}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    disabled
                />
            </Box>
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    void handleSubmit(onSubmit)(e);
                }}
            >
                <div className="relative px-[16px] pt-[10px]">
                    <div className="mb-[30px]">
                        <Controller
                            name="contractType"
                            control={control}
                            // defaultValue=""
                            render={({ field }) => (
                                <Box >
                                    <FormControl fullWidth>
                                        <InputLabel id="demo-simple-select-label">Contract type*</InputLabel>
                                        <Select
                                            {...field}
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            // value={age}
                                            label="Contract type*"
                                            MenuProps={{ className: 'custom-dropdown' }}
                                            IconComponent={KeyboardArrowDownIcon}
                                            onChange={(e: any) => {
                                                if (e.target.value === 'L') {
                                                    clearErrors('rentalCount')
                                                } else {
                                                    clearErrors('expirationDate')
                                                }
                                                // @ts-ignore
                                                setValue("expirationDate", moment(new Date()))
                                                setValue("rentalCount", null)
                                                field.onChange(e.target.value)
                                            }}
                                            error={Boolean(errors.contractType)}
                                        // helperText={errors.jobTypeId?.message}
                                        >
                                            <MenuItem value="L">License</MenuItem>
                                            <MenuItem value="R">Rental</MenuItem>
                                        </Select>
                                        <FormHelperText sx={{ color: '#ED4B52', marginLeft: '0px' }}>{errors.contractType?.message}</FormHelperText>
                                    </FormControl>
                                </Box>
                            )}
                        />
                    </div>
                    <div className="mb-[30px]">
                        <Controller
                            name="expirationDate"
                            control={control}
                            // defaultValue=""
                            render={({ field }) => (
                                <LocalizationProvider dateAdapter={AdapterMoment}>
                                    <DemoContainer components={['DatePicker']}>
                                        <DatePicker
                                            label="Expiration date"
                                            // @ts-ignore
                                            value={field.value}
                                            onChange={(newValue) => field.onChange(newValue)}
                                            shouldDisableDate={shouldDisableDate}
                                            minDate={minDate}
                                            maxDate={maxDate}
                                            slotProps={{
                                                textField: () => ({
                                                    error: Boolean(errors.expirationDate),
                                                    helperText: errors.expirationDate?.message
                                                }),
                                            }
                                            }
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>

                            )}
                        />
                    </div>
                    <div className="mb-[30px]">
                        <Controller
                            name="rentalCount"
                            control={control}
                            // defaultValue={400}
                            render={({ field }) => (
                                <TextField
                                    {...field}
                                    fullWidth
                                    type='number'
                                    InputProps={{
                                        inputProps: { min: 0 }
                                    }}
                                    label="Rental count"
                                    autoComplete="off"
                                    // placeholder="Enter Rental Count"
                                    // value={field.value}
                                    error={Boolean(errors.rentalCount)}
                                    helperText={errors.rentalCount?.message}
                                />
                            )}
                        />
                    </div>
                    <div className="mb-[30px]">
                            <Controller
                                name="emailTierToAppend"
                                control={control}
                                // defaultValue=""
                                render={({ field }) => (
                                    <Box >
                                        <FormControl fullWidth>
                                            <InputLabel id="demo-simple-select-label">Email tier to append</InputLabel>
                                            <Select
                                                {...field}
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                // value={age}
                                                label="Email tier to append"
                                                MenuProps={{ className: 'custom-dropdown' }}
                                                IconComponent={KeyboardArrowDownIcon}
                                                // onChange={handleChange}
                                                error={Boolean(errors.emailTierToAppend)}
                                            // helperText={errors.jobTypeId?.message}
                                            >
                                                <MenuItem value="1">Tier 1</MenuItem>
                                                <MenuItem value="2">Tier 2</MenuItem>
                                                <MenuItem value="3">Tier 3</MenuItem>
                                                <MenuItem value="4">Tier 4</MenuItem>
                                            </Select>
                                            <FormHelperText sx={{ color: '#ED4B52', marginLeft: '0px' }}>{errors.emailTierToAppend?.message}</FormHelperText>
                                        </FormControl>
                                    </Box>
                                )}
                            />
                        </div>
                </div>
                <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
                <div className="w-full relative col-span-3">
                    <button type='button' className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted" disabled={isLoading} onClick={closeModal}>Cancel</button>
                </div>
                <div className="w-full relative col-span-3">
                    <button className={`btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]`}
    disabled={isLoading}>{!isLoading ? 'Convert' : <span className="loading loading-spinner loading-xs text-white"></span>}</button>
                </div>
            </div>

                {/* <div className="flex items-center fixed left-0 bottom-0 w-[100%]">
                    <button type="button" className="w-[50%] bg-white h-[45px] border border-inputborder text-muted flex font-semibold text-[15px] items-center justify-center" disabled={isLoading} onClick={closeModal}>
                        Cancel
                    </button>
                    <button type="submit" className="w-[50%] h-[45px] bg-gradient-to-b border-0 from-[#ED4B52] to-[#D6242C] h-[55px text-white flex font-semibold text-[15px] items-center justify-center" disabled={isLoading}>
                        {!isLoading ? 'Convert' : <span className="loading loading-spinner loading-xs text-white"></span>}
                    </button>
                </div> */}
            </form>
        </React.Fragment>
    )
}

export default ConvertToOrder